import Search from './Search'

const SearchPageRouter = () => {
  return <Search />
}

export default SearchPageRouter
